import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '@/lib/react-query';
import { ResourceBookingsControllerFindBookingsV1Params, getSMPBackendAPIAdmin } from '@/proxy';
import { toResourceBooking } from '@/services';

function getBookings(params: ResourceBookingsControllerFindBookingsV1Params) {
  return getSMPBackendAPIAdmin().resourceBookingsControllerFindBookingsV1(params);
}

export function useMyBookings(params: ResourceBookingsControllerFindBookingsV1Params) {
  return useQuery({
    queryKey: queryKeys.resourceBookings.lists(params.status),
    queryFn: () => getBookings(params),
    select: (data) => data.map(toResourceBooking),
  });
}
